import { render, staticRenderFns } from "./ProjectsStateListComponent.vue?vue&type=template&id=b79821be&"
import script from "./ProjectsStateListComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsStateListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports